// extracted by mini-css-extract-plugin
export default {"passwordStrength":"PasswordStrengthIndicator_passwordStrength__0y1Zb","label":"PasswordStrengthIndicator_label__yR+53"};